import { makeStyles } from "@fluentui/react-components";

export const useSuggestionTypeSwitchStyles = makeStyles({
  searchTypeContainer: {
    display: "flex",
    flexDirection: "row",
    columnGap: "4px",
    alignItems: "center",
    alignContent: "center",
  },
});
